// HTML Entity map obtained from the following
// https://www.w3.org/wiki/Common_HTML_entities_used_for_typography
// https://html.spec.whatwg.org/multipage/named-characters.html
export const ENTITY_MAP = {
    "&AMP": "\u0026",
    "&AMP;": "\u0026",
    "&amp": "\u0026",
    "&amp;": "\u0026",
    "&nbsp": "\u00A0",
    "&nbsp;": "\u00A0",
    "&lt": "\u003C",
    "&lt;": "\u003C",
    "&LT": "\u003C",
    "&LT;": "\u003C",
    "&GT": "\u003E",
    "&GT;": "\u003E",
    "&gt": "\u003E",
    "&gt;": "\u003E",
    "&quot": "\u0022",
    "&quot;": "\u0022",
    "&QUOT": "\u0022",
    "&QUOT;": "\u0022",
    "&apos;": "\u0027",
    "&cent": "\u00A2",
    "&cent;": "\u00A2",
    "&pound": "\u00A3",
    "&pound;": "\u00A3",
    "&yen": "\u00A5",
    "&yen;": "\u00A5",
    "&euro;": "\u20AC",
    "&COPY": "\u00A9",
    "&COPY;": "\u00A9",
    "&copy": "\u00A9",
    "&copy;": "\u00A9",
    "&reg": "\u00AE",
    "&reg;": "\u00AE",
    "&REG": "\u00AE",
    "&REG;": "\u00AE",
    "&TRADE;": "\u2122",
    "&trade;": "\u2122",
    "&sect": "\u00A7",
    "&sect;": "\u00A7",
    "&para": "\u00B6",
    "&para;": "\u00B6",
    "&deg": "\u00B0",
    "&deg;": "\u00B0",
    "&mdash;": "\u2014",
    "&ndash;": "\u2013",
    "&asymp;": "\u2248",
    "&ne;": "\u2260",
    "&dollar;": "\u0024",
    "&#39;": "\u0027",
    "&laquo": "\u00AB",
    "&laquo;": "\u00AB",
    "&raquo": "\u00BB",
    "&raquo;": "\u00BB",
    "&middot": "\u00B7",
    "&middot;": "\u00B7",
    "&lsquo;": "\u2018",
    "&OpenCurlyQuote;": "\u2018",
    "&rsquo;": "\u2019",
    "&CloseCurlyQuote;": "\u2019",
    "&ldquo;": "\u201C",
    "&rdquo;": "\u201D",
    "&sbquo;": "\u201A",
    "&bdquo;": "\u201E",
    "&bull;": "\u2022",
    "&bullet;": "\u2022",
    "&hellip;": "\u2026",
    "&prime;": "\u2032",
    "&Prime;": "\u2033",
};
